import type { OnboardingStatus } from '../../lib/api/modules/onboarding';

export const ONBOARDING_PATH = '/onboarding';
/** Set when a wizard step opens a settings page, so that page offers a way back. */
export const RETURN_FLAG = 'onboarding_return';

/** Screens always reachable mid-setup: the wizard itself and the account basics it relies on. */
const ALWAYS_ALLOWED = [ONBOARDING_PATH, '/change-password', '/security/setup-mfa', '/profile'];

export function isAllowedWhileOnboarding(path: string, allowedPaths: string[]): boolean {
  return [...ALWAYS_ALLOWED, ...allowedPaths].some((p) => path === p || path.startsWith(`${p}/`));
}

/** Index of the step to open: the first required to-do, else the first to-do not skipped, else the review. */
export function firstOpenIndex(s: OnboardingStatus): number {
  const req = s.steps.findIndex((v) => v.required && v.status === 'TODO');
  if (req >= 0) return req;
  const todo = s.steps.findIndex((v) => v.status === 'TODO' && !v.skipped);
  return todo >= 0 ? todo : s.steps.length;
}
